import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import useIsMobile from "components/hooks/useIsMobile";
import { useGetSubmission } from "services/signup";
import Loading from "components/common/Loading";
import LeadCard from "components/pipeline/LeadCard";
import { useParams } from "react-router-dom";
import AdvisorRanking from "components/matchmaking/AdvisorRanking";

export default () => {
  const isMobile = useIsMobile();
  const params = useParams();
  const { request, data, loading } = useGetSubmission();
  const refresh = async () => {
    await request({
      submissionRef: params.leadRef!,
    });
  };
  useEffect(() => {
    if (params.leadRef) {
      refresh();
    }
  }, [params.leadRef]);

  return (
    <Box
      sx={{
        margin: isMobile ? "" : "auto",
        maxWidth: "1000px",
        padding: isMobile ? "20px 20px 0px 20px" : "64px 64px 0 64px",
      }}
    >
      <Box display="flex" flexDirection="row">
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          marginBottom="16px"
        >
          <Breadcrumbs
            breadcrumbs={[
              { name: "Home", link: "/" },
              { name: "Tools", link: "/tools" },
            ]}
          />
          <Box
            display="flex"
            width="100%"
            gap={isMobile ? "12px" : "24px"}
            {...(isMobile && { flexDirection: "column" })}
            {...(!isMobile && {
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            })}
          >
            <Box
              display="flex"
              flexDirection="row"
              gap="12px"
              alignContent="center"
            >
              <Typography variant="display">Matchmaking</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: "16px",
          paddingBottom: "16px",
        }}
      >
        {loading && <Loading />}
        {data?.submission && (
          <>
            <LeadCard
              key={data.submission.ref}
              lead={data.submission}
              onClose={() => {}}
              onOpen={() => {}}
              refresh={refresh}
              hideActions={true}
            />
            <AdvisorRanking lead={data?.submission} onStarted={refresh} />
          </>
        )}
      </Box>
    </Box>
  );
};
